<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() { },
  computed: {
    menuList() {
      return this.$store.state.menuList;
    },
    topMenuList() {
      return this.$store.getters.topMenuList;
    },
  },
  watch: {
    $route(to, from) {
      if (this.menuList.length > 0) {
        console.log(this.$route)
        this.getButtonList(this.menuList);
        if (to.path !== from.path) {
          const url = to.path;
          const index = this.findMenuIndexByUrl(this.topMenuList, url);
          if (index !== -1) {
            this.$store.commit("setMainMenuIndex", index);
          }
        }
      }
    }
  },
  methods: {
    getButtonList(menuList) {
      const url = this.$route.path;
      menuList.forEach((item) => {
        if (item.childNode) {
          this.getButtonList(item.childNode);
        } else if (item.url && url.includes(item.url)) {
          this.$store.commit("updateButtonList", item.button || []);
        }
      });
    },
    findMenuIndexByUrl(menuList, url, currentIndex = 0) {
      if (!menuList || currentIndex >= menuList.length) {
        return -1; // 遍历结束未找到或menuList为空
      }

      const currentItem = menuList[currentIndex];

      // 检查当前项的url是否匹配
      if (currentItem.url === url) {
        return currentIndex;
      }

      // 如果有childNode且不为空，递归查找
      if (currentItem.childNode && currentItem.childNode.length > 0) {
        const childIndex = this.findMenuIndexByUrl(currentItem.childNode, url);
        if (childIndex !== -1) {
          return currentIndex; // 返回父级的index
        }
      }

      // 继续检查下一项
      return this.findMenuIndexByUrl(menuList, url, currentIndex + 1);
    },
  },
};
</script>

<style lang="scss">
.custom-popup .vjmapgis-popup-content {
  background-color: #0effc2;
  opacity: 0.7;
}

.custom-popup .vjmapgis-popup-tip {
  border-top-color: #0effc2;
  opacity: 0.7;
}

.global-window {
  box-shadow: 0px 5px 16px 0px rgba(186, 186, 186, 0.96) !important;
  border-radius: 10px !important;
  background-color: var(--tool-bar-bg-color) !important;

  .el-dialog__header {
    border-bottom: 1px solid #eaeaea;
    height: 33px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .el-dialog__title {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: var(--tool-bar-text-color);
    }
  }

  .el-dialog__footer {
    text-align: center;
  }

  .el-dialog__headerbtn {
    top: 9px;
    right: 9px;
  }
}
</style>
<style lang="scss" scoped>
#app {
  height: 100vh;
}
</style>
